import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=authed
  const [ready, setReady] = useState(false);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("ss_token");
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ss_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setReady(true); return; }
    loadMe();
  }, [loadMe]);

  const applyAuth = useCallback((token, u) => {
    localStorage.setItem("ss_token", token);
    setUser(u);
    setReady(true);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ss_token");
    setUser(false);
    window.location.href = "/login";
  }, []);

  const value = useMemo(
    () => ({ user, ready, applyAuth, logout, refresh: loadMe }),
    [user, ready, applyAuth, logout, loadMe]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
